import { useMutation, useQueryClient } from '@tanstack/react-query';

import { postData } from 'src/app/queries';

import { marketingCampaignsQueryKey } from './get-campaigns';

type UpdateCampaignStatusPayload = {
  MarketingCampaignId: number;
};

export function useStopSendingMarketingCampaignMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (params: { campaignId: number }) => {
      await postData<UpdateCampaignStatusPayload>({
        endpoint: 'api/marketing-campaign/stop-sending-campaign',
        payload: { MarketingCampaignId: params.campaignId },
      });
    },
    onSuccess: () => queryClient.invalidateQueries(marketingCampaignsQueryKey),
  });
}
